module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "calibre1",
    attrs: {
      "id": "pgepubid00000"
    }
  }, [_vm._v("Watch The Sky")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "calibre6"
  }, [_vm._v("believe to be a lie and be caught at it—")]), _vm._v(" "), _c('div', {
    staticClass: "calibre6"
  }, [_vm._v("and something different, and far worse")]), _vm._v(" "), _c('div', {
    staticClass: "calibre6"
  }, [_vm._v("sometimes, to find it isn't a lie ...")]), _vm._v(" "), _c('h2', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('big', {
    staticClass: "calibre2"
  }, [_vm._v("by James H. Schmitz")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("It's one thing to try to get away with what you")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Illustrated by Hortens")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "figcenter"
  }, [_c('img', {
    staticClass: "calibre8",
    attrs: {
      "alt": "",
      "src": "Images/Section0003.png",
      "title": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67140bfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0001_split_000.vue
// module id = 57
// module chunks = 0